<template>

<div :class="[ 'single', { 'is-hidden': singleIsHidden }]">

    <single-header :project="project">
        <p>Zissel was a school project in preparation for the final exams.
        It is a fictitious company with a profound history and well defined traditions
        when it comes to brewing beer. Now to appeal to a younger audience they
        offer special flavored beer and a modern website. You can also enter a
        prize draw after filling out a dynamic form.</p>

    </single-header>

    <!-- SECTION -->

    <single-section>

        <img src="assets/projects/zissel/hero.jpg" alt="Website Hero">

    </single-section>

    <!-- SECTION -->

    <single-section header="Logo Redesign">

        <img src="assets/projects/zissel/comparison.jpg" alt="Comparison of the old logo with the new one">

        <p>The logo was redesigned. It shows a beer drinking glass surrounded by
        laurels to emphasize the high-quality product they are creating.
        On certain pages it has a subtle animation to draw further attention.</p>

        <video src="assets/projects/zissel/laurels.mp4" autoplay loop></video>

    </single-section>

    <!-- SECTION -->

    <single-section header="Playful Product Pallet">

        <p>To introduce new products for the party culture, they have their own
        section with whitespace around to set focus on them. Again to increases interest,
        the bottles slide in when scrolled to.</p>

        <video src="assets/projects/zissel/bottles.mp4" autoplay loop></video>

    </single-section>


</div>

</template>

<script>
import { singleHandler } from '@/modules/mixins'
export default {
    data() {
        return {
            project: {
                title:'Zissel',
                subtitle:'Private Brewery',
                role:'Business',
                background:'url("assets/projects/zissel/project-header.jpg")',
                logoSuffix:'png',
                color:'#94825a',
                features:'Vue, Animations',
                url:'https://zissel.artofmyself.com'
            }
        }
    },
    mixins: [singleHandler]
}
</script>



// WEBPACK FOOTER //
// zissel.vue?15880a99